import { createUuid } from '@app/utilities';
import BaseComponent from "./BaseComponent";
import OldInput from "./OldInput";
import Dropdown from "./Dropdown";
import { OldSwitch } from "./OldSwitch";

export default class KeyValue extends BaseComponent {
    /**
     * Paired key-value component
     * Customize what type of component separately for `key` and `value`
     * Valid components are Input/Dropdown/Label
     * @module KeyValue
     * @param {Object} props React props
     */

    constructor(props) {
        super(props);
        this.pair = this.props.value ? this.props.value : this.initPair();
        this.state = {
            // if `key` component is of type `Dropdown` maintain it's options and selection in state
            selectedKeyOption: this.getSelectedKeyOption(this.props.pairKeyView),
            pairKeyViewOptions: this.props.pairKeyView.options || [],
            // if `value` component is of type `Dropdown` maintain it's options and selection in state
            selectedValueOption: this.getSelectedValueOption(this.props.pairValueView),
            pairValueViewOptions: this.props.pairValueView.options || [],
            pairValueView: this.props.pairValueView
        };
        this.toggleKeyedLabelMenu = this.toggleKeyedLabelMenu.bind(this);
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
        this.setKeyedLabelMenuValue = this.setKeyedLabelMenuValue.bind(this);
        this.$activeKeyMenu = null;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutsideHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutsideHandler);
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initPair() {
        return {
            key: "",
            value: ""
        };
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    // TODO: UsedIn
    setConfig(key, value, action) {
        this.pair[key] = value;
        this.pair.inputIndex = this.props.inputIndex;
        this.pair.action = action;
        this.updateContext(this.pair);
    }

    /**
     * Get config proxy
     * @param {string} key
     * @returns {string}
     */
    getConfig(key) {
        return this.pair[key];
    }

    componentDidUpdate(prevProps, prevState) {
    
        if(this.props.layout && this.props.layout === 'keyedLabel'){
            const propsSuggestion = this.props.pairValueView.suggestion;
            const stateSuggestion = this.state.pairValueView.suggestion;
            const $pairValueView = _.cloneDeep(this.state.pairValueView);

            if(propsSuggestion !== stateSuggestion){
                $pairValueView.suggestion = propsSuggestion;
                this.setState({pairValueView: $pairValueView});
            }
        }

        // value option update
        if (prevProps.pairValueView.type === 'Dropdown' && prevProps.value.value !== '') {
            const valueSelectionHasChanged = prevState.selectedValueOption === -1 || prevProps.value.value !== prevState.pairValueViewOptions[prevState.selectedValueOption].value;
            if (valueSelectionHasChanged) {
                const selectedOption = this.getSelectedValueOption(prevProps.pairValueView);
                this.setState({ selectedValueOption: selectedOption });
            }
        }
        if (prevProps.pairKeyView.type === 'Dropdown' && prevState.selectedKeyOption !== -1) {
            const keySelectionHasChanged = prevProps.value.key !== prevState.pairKeyViewOptions[prevState.selectedKeyOption].value;
            if (keySelectionHasChanged) {
                const selectedOption = this.getSelectedValueOption(prevProps.pairKeyView);
                this.setState({ selectedKeyOption: selectedOption });
            }
        }

    }
    shouldComponentUpdate(nextProps){
       if(nextProps.value["key"]!==this.pair["key"]||nextProps.value["value"]!==this.pair["value"]){
           this.pair = nextProps.value;
       }

        return true;
    }
    /**
     * Returns selected option index for `key` Dropdown component
     * @param {object} keyView 
     * @returns number
     */
    getSelectedKeyOption(keyView) {
        if (this.props.pairKeyView.type !== 'Dropdown') {
            return -1;
        }

        const options = keyView.options;
        const value = this.props.value.key;
        const selectedOption = options.findIndex(opt => opt.value === value);

        return selectedOption;
    }
    
    /**
     * Returns selected option index for `value` Dropdown component
     * @param {object} keyView 
     * @returns number
     */
    getSelectedValueOption(valueView) {
        if (this.props.pairValueView.type !== 'Dropdown') {
            return -1;
        }

        const options = valueView.options;
        const value = this.props.value.value;
        const selectedOption = options.findIndex(opt => opt.value === value);

        return selectedOption;
    }
/**
    * If `key` is dropdown and `value` is input, this method resets the key input to varName/value/empty based on dropdown value
    * @param {object} valueView 
    */
   resetPairValueView(value) {
       if (this.props.pairValueView && !this.props.pairValueView.resetPairValueView) return;
       if (value) {
           if (value === "variable") return this.props.pairValueView.input.varName;
           if (value === "value") return this.props.pairValueView.input.value;
           if (value === "none") return "";
       }
   }
    /**
     * If `key` is dropdown and `value` is input, this method resets the key dropdown to default value when input is empty
     * See src/models/nodes/ReportNodeModel.js usage in viewConfig
     * @param {object} value 
     */
    resetSelectedKeyOption(value) {
        if (this.props.pairValueView && !this.props.pairValueView.resetKeyOnValueCleared) return;

        if (value.trim().length === 0) {
            const defaultKeyIndex = this.props.pairKeyView.defaultKeyIndex || 0;
            const defaultOptionValue = this.props.pairKeyView.options[defaultKeyIndex].value;
            this.setConfig('key', defaultOptionValue);
            this.setConfig('value', '');
            this.setState({ selectedKeyOption: defaultKeyIndex });
        }

    }

    // allow boolean inputs to accept aap/mod variable values
    getKeyedLabelViewType(){
        const variableType = this.props.pairValueView.variable.props.config.type // ["STRING"| "ARRAY"| "OBJECT"| "NUMBER"| "PROMPT"| "MODULE"| "BOOLEAN"]
        const inputType = this.state.pairValueView.input.type; // ['value' | 'variable]

        return (variableType === 'BOOLEAN' && inputType !== 'variable') ? 'Switch' : 'Input';
    }

    renderKeyedLabelComponent(){
        const viewType = this.getKeyedLabelViewType(); // ['Switch' | 'Input']

        if(viewType === 'Input') {

            const valRules = this.props.pairValueView.valRules || {};
            const inputRules = this.props.pairValueView.inputRules || {};
            const val = (this.state.pairValueView.input.type === 'value') ? this.state.pairValueView.input.value : this.state.pairValueView.input.varName;

            return <OldInput
                        label={this.state.pairValueView.label}
                        context={this}
                        valKey={this.state.pairValueView.key}
                        suggestion={this.state.pairValueView.suggestion || "variable"}
                        value={val}
                        valRules={valRules}
                        inputRules={inputRules}
                        disabled={this.state.pairValueView.disabled}
                        isPropertyPanel={true}
                        />;
        }

        if(viewType === 'Switch') {
            return <OldSwitch 
                        context={this}
                        valKey={this.state.pairValueView.key}
                        checked={this.state.pairValueView.input.value}
                        disabled={this.state.pairValueView.disabled || this.pair.key === "none"}
                    />;
        }
    }

    /**
     * Render one component of the key-value group
     * @param {Object} viewConfig View configuration
     * @returns {XML}
     */
    renderComponent(viewConfig) {
        const hint = viewConfig.hasOwnProperty("hint") ? viewConfig.hint : "";
        
        const autoCompleteConversationVariable = viewConfig.hasOwnProperty("autoCompleteConversationVariable") ? viewConfig.autoCompleteConversationVariable : false;
        switch (viewConfig.type) {
            case "Input":
                const valRules = viewConfig.hasOwnProperty("valRules") ? viewConfig.valRules : {};
                const inputRules = viewConfig.hasOwnProperty("inputRules") ? viewConfig.inputRules : {};
                
                if (viewConfig.key === 'key') {
                    return <OldInput
                        label={viewConfig.label}
                        hint={hint}
                        context={this}
                        valKey={viewConfig.key}
                        value={this.getConfig(viewConfig.key)}
                        valRules={valRules}
                        inputRules={inputRules}
                        disabled={viewConfig.disabled} 
                        keyType={viewConfig.keyType}
                        autoCompleteConversationVariable = {autoCompleteConversationVariable}
                        suggestion = {viewConfig.suggestion || "variable"}
                        isPropertyPanel={true}
                        />
                }

                if (viewConfig.key === "value") {
                    return <OldInput
                        label={viewConfig.label}
                        hint={hint}
                        context={this}
                        valKey={viewConfig.key}
                        suggestion={viewConfig.suggestion || "variable"}
                        value={this.getConfig(viewConfig.key)}
                        valRules={valRules}
                        inputRules={inputRules}
                        disabled={viewConfig.disabled}
                        isPropertyPanel={true}
                        />;
                }
                break;
            case "Switch":
                if(this.props.value.key === 'variable' || this.state.pairValueView.key === 'variable'){
                    return <OldInput
                        label={viewConfig.label}
                        hint={hint}
                        context={this}
                        valKey={viewConfig.key}
                        suggestion={viewConfig.suggestion || "variable"}
                        value={this.getConfig(viewConfig.key)}
                        valRules={valRules}
                        inputRules={inputRules}
                        disabled={viewConfig.disabled} />;
                }
                else {
                    return <OldSwitch 
                        context={this}
                        valKey={viewConfig.key}
                        checked={this.state.pairValueView.value}
                        disabled={viewConfig.disabled || this.pair.key === "none"}
                    />
                }
                break;
            case "Dropdown":
                if (viewConfig.key === "key") {
                    return <Dropdown
                        label={viewConfig.label}
                        optionName={viewConfig.optionName}
                        context={this}
                        valKey={viewConfig.key}
                        options={viewConfig.options}
                        selection={this.state.selectedKeyOption}
                        readOnly={viewConfig.disabled} />;
                }

                if (viewConfig.key === "value") {
                    return <Dropdown
                        label={viewConfig.label}
                        optionName={viewConfig.optionName}
                        context={this}
                        valKey={viewConfig.key}
                        options={viewConfig.options}
                        selection={this.state.selectedValueOption}
                        readOnly={viewConfig.disabled} />;
                }
                break;

            case "Label":
                return (
                    <div className="form-component-container">
                        <div className="form-component label">{this.getConfig(viewConfig.key)}</div>
                    </div>
                );
                break;
        }
    }

    renderKeyedLabelUI(){
        return (
            <div className="form-component-container">
                {this.getLabel()}
                <table className="key-value" style={{width: '100%'}}>
                    <tbody>
                        <tr>
                        {/* NOTE: 
                            renderKeyedLabelComponent uses state that has been initialized with props on constructor, 
                            vs. renderComponent in renderDefaultUI, which passes the initial props without setting initial state 
                        */}
                            <td className="value">{this.renderKeyedLabelComponent()}</td>
                            {this.props.allowDelete && (
                                <td className="icon"
                                    onClick={ () => {
                                        this.props.context.remove(this.props.valKey);
                                    }}
                                ><i className="fe icon-trash-2" /></td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderDefaultUI(){
        return (
            <div className="form-component-container">
                {this.getLabel()}
                <table className="key-value"><tbody><tr>
                    <td className="key">{this.renderComponent(this.props.pairKeyView)}</td>
                    <td className="pair-sep">
                        {this.getIcon()}
                    </td>
                    <td className="value">{this.renderComponent(this.props.pairValueView)}</td>
                    {this.props.allowDelete && (
                        <td className="icon"
                            onClick={event => {
                                this.props.context.remove(this.props.valKey);
                            }}
                        ><i className="fe icon-trash-2" /></td>
                    )}
                </tr></tbody></table>
            </div>
        );

    }

    getLabel(){
        const layout = this.props.layout || 'default';

        if (layout === 'keyedLabel') {
            return this.renderKeyedLabel();
        } else {
            return <label>{this.props.label}</label>;
        }
    }

    /**
     * show/hide key menu
     * @param {*} event 
     */
    toggleKeyedLabelMenu(event){
        // if target is on, turn off
        const inputIndex = this.props.inputIndex;
        const selector = $('.keyMenu');

        selector.each((idx, menu) => {
            if(parseInt(menu.dataset.menuindex, 10) === inputIndex){
                this.$activeKeyMenu = $(menu);
                $(menu).toggle()
            }
            else {
                $(menu).hide()
            }
        })

    }

    getKeyedLabelMenuItems(){
        const options = this.props.pairKeyView.options || [];
        const optionsList = [];
        
        options.forEach(opt => {    
            optionsList.push(this.getKeyedLabelMenuListItem(opt))
        });

        return optionsList;
    }

    getKeyedLabelMenuListItem(opt){
        const name = opt.name;
        return (<li
                key={createUuid()}
                className="keyedLabelMenuListItem"
                data-value={opt.action}
                onClick={this.setKeyedLabelMenuValue}>{name}</li>)
    }

    getToolTip(variableName){
        const module = window.apm.serialized.components.modules.find(mo=>mo.id===this.props.context.props.parentComponentID);
        const variable = module.localVariables.find(l=>l.name===variableName);
        return variable.props.config.description?variable.props.config.description:variable.props.config.type
    }
    renderKeyedLabel(){
        return (
            <div style={{position: 'relative'}}>
                
                <div style={{display: 'flex', alignItems: 'center'}}>
              
                    <span data-tip={this.getToolTip(this.props.variableName)}>
                        
                        <span
                            className="tooltip-label" 
                            style={{wordBreak: 'break-word'}}>
                                {this.props.variableName} 
                        </span>
                        
                        <span 
                            className="tool-tip-icon">
                                {(this.getToolTip(this.props.variableName)) ? <i className="fe icon-info"/> : ''}
                        </span>
                    </span>
                    <span style={{padding: "2px 5px"}}>
                        <a 
                            onClick={this.toggleKeyedLabelMenu} 
                            style={{cursor: 'pointer', textDecoration: 'none'}}>
                            <i 
                                className={"fe icon-plus-circle"}
                                style={{
                                    color: 'var(--theme-background-nearest)',
                                    backgroundColor: 'var(--theme-text-emphasis)',
                                    fontSize: '.8em',
                                    borderRadius: 'var(--radius-round)'
                                }}
                                /> 
                        </a>
                    </span>

                </div>
                <div className={"keyMenu " + this.props.inputIndex} 
                     data-menuindex={this.props.inputIndex}
                     style={{display: 'none', 
                        position: 'absolute',
                        top: '12px',
                        left: '53px',
                        backgroundColor: 'var(--theme-background-nearest)',
                        border: '1px solid',
                        borderColor: 'var(--theme-border)',
                        borderRadius: 'var(--radius-small)',
                        boxShadow: 'var(--theme-shadow-color) 1px 2px 7px 1px',
                        zIndex: '2000'}}>
                            <ul 
                                className="keyedLabelMenu"
                            >
                            {this.getKeyedLabelMenuItems()}
                            </ul>
                </div>
            </div>
        );
    }

    /**
     * Key is a hidden menu item. Directly manages data of module input.type|value vs via ModuelNodeModel.setConfig
     * Also manages KeyValue UI state
     * @param {*} event 
     */
    setKeyedLabelMenuValue(event){
        const action = event.target.dataset.value;
        const defaultValue = this.props.pairValueView.input.defaultValue;
        const varName = this.props.pairValueView.input.varName ? this.props.pairValueView.input.varName : '';
        
        this.toggleKeyedLabelMenu();

        if(action === 'reset-default'){
            this.setConfig('value', this.props.pairValueView.defaultValue, action);
        }

        if(action === 'toggle-variable-reference'){
            this.setConfig('value', varName, action);            
        }
        window.apm.setSerializedChanged();    
        
    }

    /**
     * Handle mouse event happening outside the reference node
     * @param {Object} event React event
     */
    handleClickOutside(event) {
        if(!this.$activeKeyMenu) {
            return;
        }
        if (this.$activeKeyMenu.contents().find(event.target).length === 0 
                || event.target.classList.contains('icon-plus-circle')) {
            this.$activeKeyMenu.hide();
            this.$activeKeyMenu = null;
            return false;
        }
    }

    getIcon(){
        if (this.props.icon) {
            return <i className={"fe icon-" + this.props.icon} />
        }
        else {
            return ":";
        }
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const layout = this.props.layout || 'default';

        if(layout === 'keyedLabel')
        {
            return this.renderKeyedLabelUI();
        }
        else {
            return this.renderDefaultUI();
        }
        
    }
}
